import { GetServerSideProps } from 'next';
import { defineMessages, useIntl } from 'react-intl';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

import SceneCardContainer from '@/components/app/scenes/SceneCardContainer';
import Layout from '@/components/layout/LayoutWrapper';
import { InitRequest, useInitState } from '@/hooks/store';

const messages = defineMessages({
	title: {
		id: 'app.components.screenTitle.scenesHeading',
		defaultMessage: 'Scenes',
		description: 'The title of the scenes selection page (background video that plays)',
	},
});

const Scenes = () => {
	useInitState({ requests: [InitRequest.USER, InitRequest.DEVICE] });
	const { formatMessage } = useIntl();

	return (
		<Layout pageName="scenes">
			<Text el="h1" color="white" weight={FontWeights.Regular} size={FontSizes.xl}>
				{formatMessage(messages.title)}
			</Text>
			<SceneCardContainer />
		</Layout>
	);
};

export default Scenes;

// Was statically generated (no revalidate — built once, served forever), which is
// incompatible with the per-request CSP nonce LayoutScripts' inline scripts now
// carry: the baked-in nonce attribute would never match proxy.ts's fresh
// per-request nonce on the response header, guaranteeing a violation on every
// view. Nothing here is actually per-request data — this is a constant-shaped
// props object — so the only cost of moving to SSR is losing the free static
// caching, which this authenticated in-app page didn't have much traffic
// pressure to justify anyway.
export const getServerSideProps: GetServerSideProps = async () => {
	return {
		props: {
			appHeaderProps: {
				pageTitle: messages.title,
			},
			initialState: {
				theme: {
					webAppLayout: 'full',
				},
			},
		},
	};
};
